import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AuthLinks from './AuthLinks';
import AnonLinks from './AnonLinks';

const mapStateToProps = ({ api: { auth } }) => ({ auth });

const ActionLinks = ({ auth }) => (
  <Fragment>
    {auth && <AuthLinks />}
    {!auth && <AnonLinks />}
  </Fragment>
);

ActionLinks.propTypes = {
  auth: PropTypes.bool
};

export default connect(mapStateToProps)(ActionLinks);
